<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-xs-12">
                <div class="widget clearfix">
                    <div class="widget-title">
                        <h3>About US</h3>
                    </div>
                    <p> We build technology for world of smarter assets</p>
                    <p></p>
                </div><!-- end clearfix -->
            </div><!-- end col -->

            <div class="col-lg-4 col-md-4 col-xs-12">
                <div class="widget clearfix">
                    <div class="widget-title">
                        <h3>Information Link</h3>
                    </div>
                    <ul class="footer-links">
                        <li><a routerLink="/home">Home</a></li>
                        <li><a href="#">Blog</a></li>
                        <li><a routerLink="/pricing">Pricing</a></li>
                        <li><a routerLink="/about">About</a></li>
                        <li><a href="#">Faq</a></li>
                        <li><a routerLink="/contact">Contact</a></li>
                    </ul><!-- end links -->
                </div><!-- end clearfix -->
            </div><!-- end col -->
            
            <div class="col-lg-4 col-md-4 col-xs-12">
                <div class="widget clearfix">
                    <div class="widget-title">
                        <h3>Contact Details</h3>
                    </div>

                    <ul class="footer-links">
                        <li><a href="mailto:#">info@ANYSPACE.com</a></li>
                        <li><a href="#">www.ANYSPACE.com</a></li>
                        <li>skype: live:.cid.ba262b95974a4e19</li>
                        <li></li>
                    </ul><!-- end links -->
                </div><!-- end clearfix -->
            </div><!-- end col -->
            
        </div><!-- end row -->
    </div><!-- end container -->
</footer>

<div class="copyrights">
    <div class="container">
        <div class="footer-distributed">
            <div class="footer-left">                   
                <p class="footer-company-name">All Rights Reserved. &copy; 2021 <a href="#">ANYSPACE inc</a> Design By : <a href="https://html.design/">html design</a></p>
            </div>

            <div class="footer-right">
                <ul class="footer-links-soi">
                    <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                    <li><a href="#"><i class="fa fa-github"></i></a></li>
                    <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                    <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
                    <li><a href="#"><i class="fa fa-pinterest"></i></a></li>
                </ul><!-- end links -->
            </div>
        </div>
    </div><!-- end container -->
</div>

<a href="#" id="scroll-to-top" class="dmtop global-radius"><i class="fa fa-angle-up"></i></a>
